// auth-messages — mapeia códigos de erro do motor (AuthErrorCode) e do fluxo
// Google pra chaves de i18n. Centralizado pra login/signup/Google usarem a mesma
// copy e o gate de i18n cobrar paridade num lugar só.

import type { AuthErrorCode, ResetErrorCode } from '../auth/account-auth'

/** Chave i18n pra um erro do motor de auth. */
export function authErrorKey(code: AuthErrorCode): string {
  switch (code) {
    case 'invalid_credentials':
      return 'mobileAuth.error.invalidCredentials'
    case 'use_google_login':
      return 'mobileAuth.error.useGoogleLogin'
    case 'email_already_registered':
      return 'mobileAuth.error.emailAlreadyRegistered'
    case 'account_suspended':
      return 'mobileAuth.error.accountSuspended'
    case 'google_email_not_verified':
      return 'mobileAuth.error.googleEmailNotVerified'
    case 'invalid_google_token':
      return 'mobileAuth.error.invalidGoogleToken'
    case 'network_error':
      return 'mobileAuth.error.network'
    case 'server_error':
      return 'mobileAuth.error.server'
    case 'unknown_error':
    default:
      return 'mobileAuth.error.unknown'
  }
}

/** Chave i18n pra um erro do fluxo de reset de senha (código por email). */
export function resetErrorKey(code: ResetErrorCode): string {
  switch (code) {
    case 'invalid_code':
      return 'mobileAuth.error.invalidResetCode'
    case 'network_error':
      return 'mobileAuth.error.network'
    case 'server_error':
      return 'mobileAuth.error.server'
    case 'unknown_error':
    default:
      return 'mobileAuth.error.unknown'
  }
}

/** Chave i18n pra um erro do fluxo do Google (load/indisponível). */
export function googleErrorKey(code: 'load_failed' | 'unavailable'): string {
  return code === 'unavailable'
    ? 'mobileAuth.googleUnavailable'
    : 'mobileAuth.error.googleLoadFailed'
}
